// extracted by mini-css-extract-plugin
export default {"pfPaymentBox":"pfPayment_pfPaymentBox__mFWmy","pfPaymentPaper":"pfPayment_pfPaymentPaper__oPbQH","pfPaymentDivider":"pfPayment_pfPaymentDivider__5W-rj"};